import styled from 'styled-components';

export const Table = styled.div`
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d5d9dd;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #ffffff;
  margin-top: 12px;
  overflow: hidden;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: auto;

  ${p => p.background && `
    background: ${p.background};
  `}
`;

export const Cell = styled.div`
  flex: 1;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  padding: 13px 22px;

  ${p => p.color && `
    color: ${p.color};
  `}

  ${p => p.fontWeight && `
    font-weight: ${p.fontWeight};
  `}

  ${p => p.background && `
    background: ${p.background};
  `}
`;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/components/table.js